/**
 *
 * TreatmentDatePicker
 *
 */

import * as PropTypes from "prop-types";
import styled from "styled-components";
import TimeWindow from "./TimeWindow";
import moment from "moment";
import { hasRole, ROLES } from "utils/userStorage";

export default function TreatmentDatePicker({
  timeWindows,
  onTimeWindowSelected,
  locale,
}) {
  // sort added on timeWindows to be sure it is sorted correctly
  //filter timer windows to make sure they are in the selected dagdeel range (bumbal returns proposals outside of range for some reason)
  if(Object.keys(timeWindows).length > 0 && window.selectedTimeslot){
    timeWindows
    var windowfrom = moment(window.selectedTimeslot.planned_date_time_from)
    var windowto  = moment(window.selectedTimeslot.planned_date_time_to)
    for(var key in timeWindows){
      var windows = timeWindows[key]
      
      if(hasRole([ROLES.Admin,ROLES.CS,ROLES.KPT]) == false){
        windows = windows.filter(w => {
          
          var timesugfrom = moment(w.timewindow.proposed_plan_date_time_from)
          var timesugto = moment(w.timewindow.proposed_plan_date_time_to)
          var a = timesugfrom.isBetween(windowfrom,windowto,null,"[]")
          var b = timesugto.isBetween(windowfrom,windowto,null,"[]")
          return a && b
        })
      }
      timeWindows[key] = windows
    }
  }
  return (
    <Wrapper id="TreatmentDatePicker">
      <TimeWindows>
        {Object.keys(timeWindows).map(key => (
          <TimeWindow
            id={`${key}`}
            onClick={onTimeWindowSelected}
            key={`${key}`}
            times={timeWindows[key].sort()}
            date={key}
            locale={locale}
          />
        ))}
      </TimeWindows>
    </Wrapper>
  );
}

TreatmentDatePicker.propTypes = {
  timeWindows: PropTypes.object.isRequired,
  onTimeWindowSelected: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
};

const TimeWindows = styled.div`
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;

  /* display: grid;
  grid-template-areas:
    "item item"
    "item item"
    "item item";
  grid-column-gap: 20px;
  grid-row-gap: 15px; */
`;

const Wrapper = styled.div`
  margin-bottom: 15px;
`;
